import { Injectable, computed, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ATTACHMENTS_HANDLER_CONFIG } from '../config/attachments-handler.config';
import type { SystemConfig } from '../models/api/api-responses.model';


@Injectable({
    providedIn: 'root',
})
export class SystemConfigService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(ATTACHMENTS_HANDLER_CONFIG).apiUrl;

    private readonly _config = signal<SystemConfig | null>(null);

    readonly config = computed(() => this._config());
    readonly name = computed(() => this._config()?.name ?? '');
    readonly logo = computed(() => this._config()?.logo ?? '');
    readonly title = computed(() => this._config()?.title ?? '');
    readonly theme = computed(() => this._config()?.theme ?? '');

    load(): void {
        this.http
            .get<SystemConfig>(`${this.baseUrl}configuration/system`)
            .subscribe({
                next: (data) => this._config.set(data),
                error: (err) => console.error('Failed to load system configuration:', err),
            });
    }
}
